// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3_Iyv","inner":"Form_inner__1fUaP","range":"Form_range__1B30E","name":"Form_name__37_7J","actions":"Form_actions___Zz3F"};